import React, { Component } from 'react';
import { withRouter, Link } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { RULESMESSAGE } from '../../../_constants';
import { getInTouchUserAction } from '../../../actions/SignUp';
import '../../../index.css';
import { notification } from 'antd';
let Validator = require('validatorjs');
let styleData = { color: "red" }
let formArr = {};
let rules = {
    email: 'required|email'
};

let validation = [];
validation = new Validator([], rules, RULESMESSAGE);
validation.passes();
validation.fails();

let fieldsArr = [];

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            header: "",
            email: "",
            formArr: {},
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.getInTouch && nextProps.getInTouch.response && nextProps.getInTouch.response.statusCode == 200 && this.state.email) {
            notification.success({
                message: nextProps.getInTouch.response.msg,
                className:'successNotification',
                duration: 3
            });
            this.setState({
                email: "",
                formArr: []
            })
        }
    }

    allValidate(check) {
        if (!check) {
            const { formArr } = this.state
            Object.keys(rules).forEach(function(key) {
                formArr[key] = "TT";
            });
            this.setState({
                formArr: formArr
            });
        }
        if (validation.passes()) {
            return 1;
        }
    }

    getInTouch = () => {
        if (this.allValidate(false)) {
            this.props.getInTouchUserAction({ email: this.state.email });
        }
    }

    handleChange = (e) => {
        this.setState({
            email: e.target.value
        })
    }

    render() {
        var date = new Date();
        var currentYear = date.getFullYear();
        validation = new Validator({ email: this.state.email }, rules, RULESMESSAGE);
        validation.passes();
        validation.fails();
        return (
            <footer className="footer"> 
              <div className="footerHome">
                <div className="container" >
                  <div className="row footer-text">
                  <div className="col-md-6 ">
                    <div className="foot-left-text">
                      <h2>Stay In Touch</h2>
                       <div class="input-container">
                          <input class="input-field" type="text" placeholder="Enter your E-mail" onChange={this.handleChange} value={this.state.email} name="email"></input>
                          <i class="fa fa-long-arrow-right" onClick={this.getInTouch}></i>
                      </div>
                        <span style={styleData} className="errlftmrg error">{this.state.formArr.email && validation.errors.first('email')}</span>
                   </div>
                 </div>
                </div>
               </div>
              </div>
             <div className="footer-navi">
                <div className="container" >
                  <div className="row">
                    <div className="col-md-12 footer-menu">
                      <div className="left-widgets">
                         <Link to={{ pathname: `/howItWorks` }} target="_blank">How It Works</Link>
                         {/*<Link to={{ pathname: `/blog` }} target="_blank">Blog</Link>*/}
                         <Link to={{ pathname: `/terms-condition` }} target="_blank">Terms & Conditions</Link>
                         <Link to={{ pathname: `/privecy-policy` }} target="_blank">Privacy Policy</Link>
                         <Link to={{ pathname: `/sitemap` }} target="_blank">Sitemap</Link>
                         <Link to={{ pathname: `/contact-us` }} target="_blank">Contact Us</Link>
                         <Link to={{ pathname: `/blog` }} target="_blank">Blogs</Link>
                      </div>
                      <div className="right-widgets">Copyrights © {currentYear} all rights reserved</div>
                    </div>
                  </div>
                </div>
          </div>
        </footer>

        )
    }
}

function mapStateToProps(state) {
    return {
        getInTouch: state.SignUp
    }
}


export default withLocalize(withRouter(connect(mapStateToProps, {
    getInTouchUserAction
})(Footer)));


// WEBPACK FOOTER //
// ./src/components/Inc/Layout/Footer.js